

<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />

    <b-modal
    :disabled="status === 'Concluida'"
      v-model="mostrar"
      title="Nuevo prestamo"
      cancel-title="Cancelar"
      ok-title="Generar"
      @ok="NuevoPrestamo()"
    >
      <b-form-select v-model="tipo" :options="tipoBien"></b-form-select>
    </b-modal>
    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <h4 style="text-align: center">16. PRESTAMOS</h4>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-list-group sm="12">
          <b-list-group-item v-for="(item, index) in prestamo" :key="index">
            <b-row>
              <b-col md="12">
                <div class="customHr">.</div>
              </b-col>

              <b-col sm="12">
                <h6 style="text-align: center">Prestamo</h6>
              </b-col>
              <b-col md="12">
                <div class="customHr">.</div>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>Tipo Operación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosPrestamo[index].cambios = true"
                    v-model="item.tipoOperacion"
                    :options="tipoOperacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="2">
                <b-form-group>
                  <label>Tipo dueño Titular:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosPrestamo[index].cambios = true"
                    v-model="item.duenoTitular.tipoDuenoTitular"
                    :options="tipoDuenoTitular"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col md="8">
                <b-form-group>
                  <label>Nombre Titular:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosPrestamo[index].cambios = true"
                    type="text"
                    v-model="item.duenoTitular.nombreTitular"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label>RFC:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosPrestamo[index].cambios = true"
                    type="text"
                    v-model="item.duenoTitular.rfc"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Relación con titular:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosPrestamo[index].cambios = true"
                    type="text"
                    v-model="item.duenoTitular.relacionConTitular"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <!-- INMUEBLES-->
              <b-col sm="12">
                <b-row v-if="item.bien === 'inmueble'">
                  <b-col sm="12">
                    <h6 style="text-align: center">Inmueble</h6>
                  </b-col>
                  <b-col sm="2">
                    <b-form-group>
                      <label>Tipo Inmueble:</label>
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        @change="seleccionaValorTipo(index)"
                        v-model="item.tipoBien.inmueble.tipoInmueble.clave"
                        :options="tipoInmueble"
                        text-field="valor"
                        value-field="clave"
                        class="mb-3"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group label="Lugar donde se ubica:">
                      <b-form-radio-group
                      :disabled="status === 'Concluida'"
                        @change="llenaEspacios(index)"
                        v-model="cambiosPrestamo[index].nacionalidad"
                      >
                        <b-form-radio value="Mexico">México</b-form-radio>
                        <b-form-radio value="Extranjero"
                          >Extranjero</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>

                  <!--Mexico -->
                  <b-col sm="12">
                    <b-row
                      v-if="cambiosPrestamo[index].nacionalidad === 'Mexico'"
                    >
                      <b-col md="4">
                        <b-form-group>
                          <label>Calle:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioMexico.calle
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group>
                          <label>Numero Exterior:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioMexico
                                .numeroExterior
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group>
                          <label>Numero Interior:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioMexico
                                .numeroInterior
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col md="2">
                        <b-form-group>
                          <label>Entidad Federativa:</label>
                          <b-form-select
                          :disabled="status === 'Concluida'"
                            @change="encuentraEstadoValor(index)"
                            v-model="
                              item.tipoBien.inmueble.domicilioMexico
                                .entidadFederativa.clave
                            "
                            :options="estados"
                            text-field="valor"
                            value-field="clave"
                          >
                            <template v-slot:first>
                              <option :value="null">Selecciona </option>
                            </template></b-form-select
                          >
                        </b-form-group>
                      </b-col>

                      <b-col md="2">
                        <b-form-group>
                          <label>Municipio:</label>
                          <b-form-select
                          :disabled="status === 'Concluida'"
                            @change="encuentraMuniValor(index)"
                            :options="cargaMunicipio(index)"
                            v-model="
                              item.tipoBien.inmueble.domicilioMexico
                                .municipioAlcaldia.clave
                            "
                            text-field="valor"
                            value-field="clave"
                            ><template v-slot:first>
                              <option :value="null">Selecciona </option>
                            </template></b-form-select
                          >
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group>
                          <label>Colonia Localidad:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioMexico
                                .coloniaLocalidad
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col md="2">
                        <b-form-group>
                          <label>Codigo Postal:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioMexico
                                .codigoPostal
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>

                  <!-- Extranjero -->
                  <b-col sm="12">
                    <b-row
                      v-if="
                        cambiosPrestamo[index].nacionalidad === 'Extranjero'
                      "
                    >
                      <b-col md="6">
                        <b-form-group>
                          <label>Calle:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioExtranjero.calle
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group>
                          <label>Numero Exterior:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioExtranjero
                                .numeroExterior
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group>
                          <label>Numero Interior:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioExtranjero
                                .numeroInterior
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group>
                          <label>Codigo Postal:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioExtranjero
                                .codigoPostal
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Ciudad Localidad:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioExtranjero
                                .ciudadLocalidad
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Estado Provincia:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioExtranjero
                                .estadoProvincia
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Pais:</label>
                          <b-form-input
                          :disabled="status === 'Concluida'"
                            @change="cambiosPrestamo[index].cambios = true"
                            type="text"
                            v-model="
                              item.tipoBien.inmueble.domicilioExtranjero.pais
                            "
                            placeholder="Ingrese..."
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <!-- fin extramjero-->

                  <b-col md="12">
                    <b-row style="text-align: center">
                      <b-col>
                        <b-button
                        v-if="status !== 'Concluida'"
                          variant="primary"
                          size="sm"
                          @click="guardarPrestamo(index)"
                          >Guardar</b-button
                        >
                        <p
                          v-if="cambiosPrestamo[index].cambios"
                          class="error-text"
                        >
                          <i>No se han guardado los cambios</i>
                        </p>
                      </b-col>

                      <b-col>
                        <b-button
                        v-if="status !== 'Concluida'"
                          variant="danger"
                          size="sm"
                          @click="eliminarPrestamo(index)"
                          >Eliminar prestamo</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-col>

                  <br />
                  <br />
                </b-row>
              </b-col>
              <!-- FIN INMUEBLES -->
              <!-- VEHICULO-->
              <b-col sm="12">
                <b-row v-if="item.bien === 'vehiculo'">
                  <b-col sm="12">
                    <h6 style="text-align: center">Vehiculo</h6>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label>Tipo Vehiculo:</label>
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        v-model="item.tipoBien.vehiculo.tipo.clave"
                        :options="tipoVehiculo"
                        text-field="valor"
                        value-field="clave"
                        @change="seleccionaValorVehiculo(index)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Marca:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosPrestamo[index].cambios = true"
                        type="text"
                        v-model="item.tipoBien.vehiculo.marca"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Modelo:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosPrestamo[index].cambios = true"
                        type="text"
                        v-model="item.tipoBien.vehiculo.modelo"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>Año:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosPrestamo[index].cambios = true"
                        type="text"
                        v-model="item.tipoBien.vehiculo.anio"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Numero de Serie de Registro:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosPrestamo[index].cambios = true"
                        type="text"
                        v-model="item.tipoBien.vehiculo.numeroSerieRegistro"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Lugar Registro Pais:</label>
                      <b-form-input
                        @change="cambiosPrestamo[index].cambios = true"
                        type="text"
                        v-model="item.tipoBien.vehiculo.lugarRegistro.pais"
                        placeholder="México"
                        disabled
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>Entidad Federativa:</label>
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        @change="encuentraEstadoValor_vehiculo(index)"
                        v-model="
                          item.tipoBien.vehiculo.lugarRegistro.entidadFederativa
                            .clave
                        "
                        :options="estados"
                        text-field="valor"
                        value-field="clave"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-row style="text-align: center">
                      <b-col>
                        <b-button
                        v-if="status !== 'Concluida'"
                          variant="primary"
                          size="sm"
                          @click="guardarPrestamo(index)"
                          >Guardar</b-button
                        >
                        <p
                          v-if="cambiosPrestamo[index].cambios"
                          class="error-text"
                        >
                          <i>No se han guardado los cambios</i>
                        </p>
                      </b-col>

                      <b-col>
                        <b-button
                        v-if="status !== 'Concluida'"
                          variant="danger"
                          size="sm"
                          @click="eliminarPrestamo(index)"
                          >Eliminar prestamo</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-col>

                  <br />
                  <br />
                </b-row>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
        <br />
      </b-col>
    </b-row>

    <br />

    <b-row>
      <br />

      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="mostrar = true"
          >Agregar Prestamo</b-button
        >
      </b-col>
      <br />
      <br />
      <b-col md="12">
        <b-form-group>
          <label for="funcion">ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="prestamoComodato.aclaracionesObservaciones"
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-button  variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
      <b-col md="4" style="text-align: center">
        <b-button
        v-if="status !== 'Concluida'"
          variant="primary"
          @click="actualizarObservaciones()"
          :disabled="enviando"
          >Guardar cambios</b-button
        >
        <br />
        <p v-if="cambios" class="error-text">
          <i>No se han guardado los cambios</i>
        </p>
      </b-col>
      <b-col md="2">
        <b-button
   
          variant="secondary"
          @click="verSeccion(15)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col md="2">
        <b-button

          class="pull-right"
          variant="secondary"
          @click="verSeccion(17)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { muni } from "../../../store/municipios";

export default {
  components: { Loader, Datetime },
  props: ["prestamoComodato", "status"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      tipo: "",
      tipoBien_: "",
      tipos: [],
      mostrar: false,
      contador: 0,
      contadorTransmisor: 0,
      contadorTercero: 0,
      prestamo: [{}],
      enviando: false,
      cambios: false,
      cambiosPrestamo: [],
      agregaotro: false,
      tipoOperacion: ["AGREGAR", "MODIFICAR", "SIN_CAMBIOS", "BAJA"],
      tipoDuenoTitular: ["FISICA", "MORAL"],
      formaPago: ["CRÉDITO", "CONTADO", "NO APLICA"],
      bandera: false,
      banderaEditar: false,
      municipios: muni,
      motivoBaja: [
        { clave: "VNT", valor: "VENTA" },
        { clave: "DNC", valor: "DONACION" },
        { clave: "SNT", valor: "SINIESTRO" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      tipoBien: ["Inmueble", "Vehiculo"],
      // { clave: "inmueble", valor: "Inmueble" },
      // { clave: "vehiculo", valor: "Vehiculo" }],

      tipoPersona: ["FISICA", "MORAL"],
      titular: [
        { clave: "DEC", valor: "DECLARANTE" },
        { clave: "CYG", valor: "CONYUGE" },
        { clave: "CBN", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CVV", valor: "CONVIVIENTE" },
        { clave: "DEN", valor: "DEPENDIENTE ECONÓMICO" },
        { clave: "CTER", valor: "COPROPIEDAD CON TERCEROS" }
      ],

      estados: [
        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MéXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ],
      tipoVehiculo: [
        { clave: "AUMOT", valor: "AUTOMÓVIL/MOTOCICLETA" },
        { clave: "AERN", valor: "AERONAVE" },
        { clave: "BARYA", valor: "BARCO/YATE" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      tipoInmueble: [
        { clave: "CASA", valor: "CASA" },
        { clave: "DPTO", valor: "DEPARTAMENTO" },
        { clave: "EDIF", valor: "EDIFICIO" },
        { clave: "LOCC", valor: "LOCAL COMERCIAL" },
        { clave: "BODG", valor: "BODEGA" },
        { clave: "PALC", valor: "PALCO" },
        { clave: "RACH", valor: "RANCHO" },
        { clave: "TERR", valor: "TERRENO" },
        { clave: "OTRO", valor: "OTRO" }
      ]
    };
  },
  methods: {
    NuevoPrestamo() {
      if (this.tipo === "Inmueble") {
        this.tipo = "inmueble";
      } else if (this.tipo === "Vehiculo") {
        this.tipo = "vehiculo";
      }
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/prestamoComodato/" +
            this.$route.params.id +
            "/prestamo",

          { tipoBien: this.tipo },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
      
          let objeto = {
            _id: this.contador,
            cambios: false,
            nacionalidad: "Mexico"
          };
          this.cambiosPrestamo.push(objeto);
          this.prestamo.push(res.data.prestamo);
          this.contador++;
          this.enviando = true;

          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });

          this.enviando = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },
    llenaEspacios(index) {
      if (this.cambiosPrestamo[index].nacionalidad !== "Mexico") {
        this.prestamo[index].tipoBien.inmueble.domicilioExtranjero.calle = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioExtranjero.numeroExterior = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioExtranjero.numeroInterior = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioExtranjero.ciudadLocalidad = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioExtranjero.estadoProvincia = "";
        this.prestamo[index].tipoBien.inmueble.domicilioExtranjero.pais = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioExtranjero.codigoPostal = "";
      } else {
        this.prestamo[index].tipoBien.inmueble.domicilioMexico.calle = "";
        this.prestamo[index].tipoBien.inmueble.domicilioMexico.numeroInterior =
          "";
        this.prestamo[index].tipoBien.inmueble.domicilioMexico.numeroExterior =
          "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioMexico.coloniaLocalidad = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioMexico.municipioAlcaldia.valor = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioMexico.entidadFederativa.valor = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioMexico.municipioAlcaldia.clave = "";
        this.prestamo[
          index
        ].tipoBien.inmueble.domicilioMexico.entidadFederativa.clave = "";
        this.prestamo[index].tipoBien.inmueble.domicilioMexico.codigoPostal =
          "";
      }
    },
    guardarPrestamo(index) {
      if (this.prestamo[index].bien === "inmueble") {
        if (this.cambiosPrestamo[index].nacionalidad === "Mexico") {
          this.prestamo[index].tipoBien.inmueble.domicilioExtranjero.calle = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioExtranjero.numeroExterior = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioExtranjero.numeroInterior = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioExtranjero.ciudadLocalidad = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioExtranjero.estadoProvincia = "";
          this.prestamo[index].tipoBien.inmueble.domicilioExtranjero.pais = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioExtranjero.codigoPostal = "";
        } else if (this.cambiosPrestamo[index].nacionalidad === "Extranjero") {
          this.prestamo[index].tipoBien.inmueble.domicilioMexico.calle = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioMexico.numeroInterior = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioMexico.numeroExterior = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioMexico.coloniaLocalidad = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioMexico.municipioAlcaldia.valor = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioMexico.entidadFederativa.valor = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioMexico.municipioAlcaldia.clave = "";
          this.prestamo[
            index
          ].tipoBien.inmueble.domicilioMexico.entidadFederativa.clave = "";
          this.prestamo[index].tipoBien.inmueble.domicilioMexico.codigoPostal =
            "";
        }

        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/prestamoComodato/" +
              this.$route.params.id +
              "/prestamo/" +
              this.prestamo[index]._id,
            {
              tipoOperacion: this.prestamo[index].tipoOperacion,
              tipoDuenoTitular: this.prestamo[index].duenoTitular
                .tipoDuenoTitular,
              nombreTitular: this.prestamo[index].duenoTitular.nombreTitular,
              rfc: this.prestamo[index].duenoTitular.rfc,
              relacionConTitular: this.prestamo[index].duenoTitular
                .relacionConTitular,
              tipoInmuebleClave: this.prestamo[index].tipoBien.inmueble
                .tipoInmueble.clave,
              tipoInmuebleValor: this.prestamo[index].tipoBien.inmueble
                .tipoInmueble.valor,
              MXcalle: this.prestamo[index].tipoBien.inmueble.domicilioMexico
                .calle,
              MXnumeroExterior: this.prestamo[index].tipoBien.inmueble
                .domicilioMexico.numeroExterior,
              MXnumeroInterior: this.prestamo[index].tipoBien.inmueble
                .domicilioMexico.numeroInterior,
              MXcoloniaLocalidad: this.prestamo[index].tipoBien.inmueble
                .domicilioMexico.coloniaLocalidad,
              MXmunicipioAlcaldiaClave: this.prestamo[index].tipoBien.inmueble
                .domicilioMexico.municipioAlcaldia.clave,
              MXmunicipioAlcaldiaValor: this.prestamo[index].tipoBien.inmueble
                .domicilioMexico.municipioAlcaldia.valor,
              MXentidadFederativaClave: this.prestamo[index].tipoBien.inmueble
                .domicilioMexico.entidadFederativa.clave,
              MXentidadFederativaValor: this.prestamo[index].tipoBien.inmueble
                .domicilioMexico.entidadFederativa.valor,
              MXcodigoPostal: this.prestamo[index].tipoBien.inmueble
                .domicilioMexico.codigoPostal,
              EXTcalle: this.prestamo[index].tipoBien.inmueble
                .domicilioExtranjero.calle,
              EXTnumeroExterior: this.prestamo[index].tipoBien.inmueble
                .domicilioExtranjero.numeroExterior,
              EXTnumeroInterior: this.prestamo[index].tipoBien.inmueble
                .domicilioExtranjero.numeroInterior,
              EXTciudadLocalidad: this.prestamo[index].tipoBien.inmueble
                .domicilioExtranjero.ciudadLocalidad,
              EXTestadoProvincia: this.prestamo[index].tipoBien.inmueble
                .domicilioExtranjero.estadoProvincia,
              EXTpais: this.prestamo[index].tipoBien.inmueble
                .domicilioExtranjero.pais,
              EXTcodigoPostal: this.prestamo[index].tipoBien.inmueble
                .domicilioExtranjero.codigoPostal
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            }
            this.enviando = false;
            this.cambiosPrestamo[index].cambios = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
           
          });
      } else {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/prestamoComodato/" +
              this.$route.params.id +
              "/prestamo/" +
              this.prestamo[index]._id,
            {
              tipoOperacion: this.prestamo[index].tipoOperacion,
              tipoDuenoTitular: this.prestamo[index].duenoTitular
                .tipoDuenoTitular,
              nombreTitular: this.prestamo[index].duenoTitular.nombreTitular,
              rfc: this.prestamo[index].duenoTitular.rfc,
              relacionConTitular: this.prestamo[index].duenoTitular
                .relacionConTitular,
              tipoVehiculoClave: this.prestamo[index].tipoBien.vehiculo.tipo
                .clave,
              tipoVehiculoValor: this.prestamo[index].tipoBien.vehiculo.tipo
                .valor,
              marca: this.prestamo[index].tipoBien.vehiculo.marca,
              modelo: this.prestamo[index].tipoBien.vehiculo.modelo,
              anio: this.prestamo[index].tipoBien.vehiculo.anio,
              numeroSerieRegistro: this.prestamo[index].tipoBien.vehiculo
                .numeroSerieRegistro,
              lugarRegistroPais: this.prestamo[index].tipoBien.vehiculo
                .lugarRegistro.pais,
              entidadFederativaClave: this.prestamo[index].tipoBien.vehiculo
                .lugarRegistro.entidadFederativa.clave,
              entidadFederativaValor: this.prestamo[index].tipoBien.vehiculo
                .lugarRegistro.entidadFederativa.valor
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
          
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            }
            this.enviando = false;
            this.cambiosPrestamo[index].cambios = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
        
          });
      }
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
    checarCambios(item, indice) {
      let index = this.cambiosPrestamo.findIndex(x => x._id == item._id);

      return this.cambiosPrestamo[indice].cambios;
      //return false;
    },
    seRealizaronCambiios(item) {
      let index = this.cambiosPrestamo.findIndex(x => x._id == item._id);
      this.cambiosPrestamo[index].cambios = true;
    },
    seleccionaValorTipo(index) {
      let indice = this.tipoInmueble.findIndex(
        x =>
          x.clave == this.prestamo[index].tipoBien.inmueble.tipoInmueble.clave
      );
      this.prestamo[
        index
      ].tipoBien.inmueble.tipoInmueble.valor = this.tipoInmueble[indice].valor;
    },
    encuentraEstadoValor(index) {
      let indice;
      indice = this.estados.findIndex(
        x =>
          x.clave ===
          this.prestamo[index].tipoBien.inmueble.domicilioMexico
            .entidadFederativa.clave
      );
      this.prestamo[
        index
      ].tipoBien.inmueble.domicilioMexico.entidadFederativa.valor = this.estados[
        indice
      ].valor;
    },
    encuentraEstadoValor_vehiculo(index) {
      let indice;
      indice = this.estados.findIndex(
        x =>
          x.clave ===
          this.prestamo[index].tipoBien.vehiculo.lugarRegistro.entidadFederativa
            .clave
      );
      this.prestamo[
        index
      ].tipoBien.vehiculo.lugarRegistro.entidadFederativa.valor = this.estados[
        indice
      ].valor;
    },
    encuentraMuniValor(index) {
      let indice;
      indice = this.municipios.findIndex(
        x =>
          x.clave ===
          this.prestamo[index].tipoBien.inmueble.domicilioMexico
            .municipioAlcaldia.clave
      );
      this.prestamo[
        index
      ].tipoBien.inmueble.domicilioMexico.municipioAlcaldia.valor = this.municipios[
        indice
      ].valor;
    },
    cargaMunicipio(index) {
      let listaMuni = [];
      if (Number.isInteger(index)) {
        if (
          this.prestamo[index].tipoBien.inmueble.domicilioMexico
            .entidadFederativa.clave !== null
        ) {
          this.municipios.forEach(value => {
            if (
              value.claveEstado ===
              this.prestamo[index].tipoBien.inmueble.domicilioMexico
                .entidadFederativa.clave
            ) {
              listaMuni.push(value);
            }
          });
        }
      }
      return listaMuni;
    },
    seleccionaValorVehiculo(index) {
      let indice = this.tipoVehiculo.findIndex(
        x => x.clave == this.prestamo[index].tipoBien.vehiculo.tipo.clave
      );
      this.prestamo[index].tipoBien.vehiculo.tipo.valor = this.tipoVehiculo[
        indice
      ].valor;
    },
    actualizarObservaciones() {
      this.enviando = true;

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/prestamoComodato/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",
          {
            ninguno: this.prestamoComodato.ninguno,
            aclaracionesObservaciones: this.prestamoComodato
              .aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
         
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
         
        });
    },
    eliminarPrestamo(index) {
      swal({
        text: "¿Está seguro en eliminar el Prestamo?",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/prestamoComodato/" +
                this.$route.params.id +
                "/prestamo/" +
                this.prestamo[index]._id,

              { headers: { token: this.sessionToken } }
            )
            .then(res => {
       
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });

                this.prestamo.splice(index, 1);
                this.cambiosPrestamo.splice(index, 1);
                this.contador--;
              }

              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
            });
        }
      });
    }
  },
  watch: {},

  created() {
    this.prestamo = this.prestamoComodato.prestamo;
   
    this.prestamo.forEach(Element => {
      this.tipo = Element.bien;
  

      if (Element.bien === "inmueble") {
        if (
          Element.tipoBien.inmueble.domicilioExtranjero.calle === '""' ||
          Element.tipoBien.inmueble.domicilioExtranjero.calle !== null
        ) {
          let objeto = {
            _id: Element._id,
            cambios: false,
            nacionalidad: "Mexico"
          };
          this.cambiosPrestamo.push(objeto);
        } else if (
          Element.tipoBien.inmueble.domicilioMexico.calle === '""' ||
          Element.tipoBien.inmueble.domicilioMexico.calle === null
        ) {
          let objeto = {
            _id: Element._id,
            cambios: false,
            nacionalidad: "Extranjero"
          };
          this.cambiosPrestamo.push(objeto);
        }
      } else if (Element.bien === "vehiculo") {
        let objeto = { _id: Element._id, cambios: false, nacionalidad: "n/a" };
        this.cambiosPrestamo.push(objeto);
      }
      if (
        Element.tipoOperacion === "AGREGAR" ||
        Element.tipoOperacion === null
      ) {
        Element.tipoOperacion = "MODIFICAR";
      }
    });
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
